// extracted by mini-css-extract-plugin
module.exports = {"overlay":"index_overlay__30fAz","spinContainer":"index_spinContainer__2g4_P"};